<template>
  <div>
    <validation-observer ref="detarminateForm" novalidate>
      <div class="mb-2">
        <i class="mr-2 fas fa-file mb-1 text-orange" />
        <label class="font-16 color-black font-weight-bold">
          Determinar
        </label>
      </div>

      <div class="font-16 color-black mb-2">
        Categorías:
      </div>
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-radio
          v-model="determinationCategory"
          class="custom-radio via"
          custom-error-msg="El campo es requerido."
          :disabled="determinationCategoryOptions.length === 1"
          :error="!!errors[0]"
          name="determinationCategory"
          :options="determinationCategoryOptions"
        />
      </validation-provider>
    </validation-observer>

    <div>
      <i class="mr-2 fas fa-file mb-1 text-orange" />
      <label class="font-16 color-black font-weight-bold">
        Documentos
      </label>
    </div>
    <div class="rounded p-3 bg-secondary-3 my-3">
      <custom-file-input
        :key="documents.length"
        ref="file"
        accept=".pdf"
        display-style="normal"
        :on-download="() => {}"
        @input="addFile"
      />
    </div>
    <div
      v-for="(item, key) in pagination.items"
      :key="item.id"
      class="rounded p-3 bg-secondary-3 my-3"
    >
      <div class="row">
        <div class="col-12 col-md">
          <div class="data-name">Archivo:</div>
          <div>{{ item.file.name | empty }}</div>
        </div>
        <div class="col-12 col-md">
          <div class="d-flex justify-content-end mt-1">
            <action-button
              i="fas fa-times-circle icon-mr-0"
              variant="outline-danger mr-2"
              @click="remove(key)"
            />
            <action-button
              i="fas fa-file-download icon-mr-0"
              variant="success"
              @click="download(item.file)"
            />
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-if="pagination.totalItemCount > pagination.pageSize"
      :data="pagination"
      show-text
      @pagination-go-page="(page) => (currentPage = page)"
    />
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-2"
        @click="cancel"
      />
      <action-button
        i="fas fa-save"
        text="Guardar"
        variant="success"
        @click="save"
      />
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomRadio from 'custom-radio';
import CustomFileInput from 'CustomFileInput';
import Pagination from 'pagination';
import ActionButton from 'ActionButton';

import { serialize as objectToFormData } from 'object-to-formdata';
import { determinate } from '@/modules/purchaseService/api.js';
import generalApi from '@/modules/app/api';

export default {
  name: 'Determinate',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomRadio,
    CustomFileInput,
    Pagination,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      documents: [],
      model: { determinationCategoryId: null },
    };
  },
  computed: {
    determinationCategory: {
      get() {
        return (
          this.determinationCategoryOptions.find(
            (x) => x.value === this.model.determinationCategoryId
          ) ?? {}
        );
      },
      set(option) {
        this.model.determinationCategoryId = option?.value;
      },
    },
    determinationCategoryOptions() {
      return (this.categories ?? []).map((x) => ({
        id: x.id,
        value: x.id,
        name: x.name.toLowerCase(),
        label: x.name,
      }));
    },
    pagination() {
      const pageSize = 3;
      const pageCount = Math.ceil(this.documents.length / pageSize);
      const items = this.documents.slice(
        (this.currentPage - 1) * pageSize,
        this.currentPage * pageSize
      );
      const count = items.length;
      const totalItemCount = this.documents.length;
      return {
        currentPage: this.currentPage,
        pageSize,
        pageCount,
        items,
        count,
        totalItemCount,
      };
    },
  },
  created() {
    if (this.determinationCategoryOptions.length === 1)
      this.model.determinationCategoryId = this.determinationCategoryOptions[0].value;
  },
  methods: {
    addFile(file) {
      if (!file) return;
      this.documents.unshift({ id: crypto.randomUUID(), file });
      this.$nextTick(this.$refs.file.removeFile);
    },
    cancel() {
      this.$emit('close');
    },
    async save() {
      const valid = await this.$refs.detarminateForm.validate();
      if (!valid) {
        this.ShowToast(
          '',
          'Debe completar todos los campos obligatorios para determinar la solicitud.',
          'error'
        );
        return;
      }
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea guardar la determinación?',
        'Si',
        'No'
      );

      if (!confirmed) return;

      try {
        const model = { ...this.model };
        const payload = objectToFormData(model, {
          indices: true,
          nullsAsUndefineds: true,
        });
        this.documents.forEach(({ file }) => payload.append(`files`, file));

        await determinate(this.id, payload);
        this.ShowToast('', 'Determinación guardada exitosamente.', 'success');
        this.$emit('saved', model);
      } catch {
        this.ShowToast(
          '',
          'No se pudo determinar la solicitud. Intente nuevamente o contacte al administrador.',
          'error'
        );
      }
    },
    async remove(key) {
      this.documents.splice(key, 1);
    },
    download(file) {
      generalApi.downloadFileInline(file);
    },
  },
};
</script>
<style scoped>
.custom-radio.via ::v-deep .custom-control {
  margin-bottom: 20px !important;
}
.custom-radio ::v-deep .col-12 {
  padding: 0 !important;
}
.custom-radio ::v-deep label {
  font-size: 14px !important;
  color: #727272 !important;
  padding-top: 1px;
}
::v-deep .custom-datetime-picker-container {
  width: 100% !important;
  input[type='text'] {
    width: 100%;
  }
}

::v-deep input[type='checkbox'] + label > span {
  margin-top: 0 !important;
}
::v-deep input[type='checkbox'] + label > div {
  font-size: 14px !important;
  color: #727272 !important;
}

div.was-Invalidated-select ::v-deep .v-select > div {
  background-color: #f7d7da !important;
  border: 1px solid #ff0018 !important;
}
::v-deep div.was-Invalidated {
  border: none !important;
}

::v-deep .was-Invalidated.file-input-container {
  border: 1px solid #ff0018 !important;
}

::v-deep .icon-mr-0 {
  margin-right: 0 !important;
}
</style>
